import Router from 'next/router';
import React from 'react';
import { useDispatch } from 'react-redux';
import { logPageView } from '../analytics';
import { actionPopupDidLoadPage } from '../redux/actions';
import { setNewIdentityIfNeeded } from '../utils/identity';
import { PageView } from '../utils/pageView';
import { createNewSessionIfNeeded } from '../utils/analyticsSession';
import PopupToVBBridge from './Meeting/Messaging/PopupBridge/PopupToVBBridge';
import PageScrollListener from './PageScrollListener';
import GA from './Tracking/GA';

type GeoLocation = {
  country: string;
  city: string;
};
const PageViewLogger = (props: {
  children: React.ReactNode;
  pageView: PageView;
  storeId?: string;
  brandId?: string;
  uuid?: string;
  geo?: GeoLocation;
}) => {
  const dispatch = useDispatch();

  const handleRouteChange = (url) => {
    dispatch(actionPopupDidLoadPage(url));
  };
  React.useEffect(() => {
    window['brandId'] = props.brandId;
    window['uuid'] = props.uuid;
    window['storeId'] = props.storeId;
    window['country'] = props.geo?.country;
    window['city'] = props.geo?.city;
    setNewIdentityIfNeeded();
    createNewSessionIfNeeded(props.storeId);
    logPageView(props.storeId, props.pageView);
    Router.events.on('routeChangeStart', handleRouteChange);
    return () => {
      Router.events.off('routeChangeStart', handleRouteChange);
    };
  }, []);

  return (
    <GA storeId={props.storeId}>
      <PageScrollListener>
        <PopupToVBBridge>{props.children}</PopupToVBBridge>
      </PageScrollListener>
    </GA>
  );
};

export default PageViewLogger;
